import * as Yup from 'yup';

export const flowEditorSidebarValidationSchema = Yup.object().shape({
    search: Yup.string(),
    selectedGroups: Yup.array().of(Yup.string()),
});
